import type { ISerialize } from '@/objects/ISerialize';

export class LoginRequest implements ISerialize {
    public DeviceFingerprint: string | null;

    public Language: string | null;

    public Password: string;

    public TrustDevice: boolean;

    public TwoFactorCode: string | null;

    public Username: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        DeviceFingerprint?: string | null;
        Language?: string | null;
        Password?: string | null;
        TrustDevice?: boolean;
        TwoFactorCode?: string | null;
        Username?: string | null;
    }) {
        this.DeviceFingerprint = values.DeviceFingerprint ?? null;

        this.Language = values.Language ?? null;

        this.Password = values.Password ?? '';

        this.TrustDevice = values.TrustDevice ?? false;

        this.TwoFactorCode = values.TwoFactorCode ?? null;

        this.Username = values.Username ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"DeviceFingerprint": ${JSON.stringify(this.DeviceFingerprint)}` +
            ',' +
            `"Language": ${JSON.stringify(this.Language)}` +
            ',' +
            `"Password": ${JSON.stringify(this.Password)}` +
            ',' +
            `"TrustDevice": ${JSON.stringify(this.TrustDevice)}` +
            ',' +
            `"TwoFactorCode": ${JSON.stringify(this.TwoFactorCode)}` +
            ',' +
            `"Username": ${JSON.stringify(this.Username)}` +
            '}'
        );
    }

    /**
     * Creates an instance of LoginRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        DeviceFingerprint?: string | null;
        Language?: string | null;
        Password?: string | null;
        TrustDevice?: boolean;
        TwoFactorCode?: string | null;
        Username?: string | null;
    }): LoginRequest {
        return new LoginRequest(values);
    }

    public static _FromServerJson(json: any): LoginRequest {
        return new LoginRequest({
            DeviceFingerprint: json.DeviceFingerprint ?? '',
            Language: json.Language ?? '',
            Password: json.Password ?? '',
            TrustDevice: json.TrustDevice,
            TwoFactorCode: json.TwoFactorCode ?? '',
            Username: json.Username ?? '',
        });
    }

    /**
     * Creates an instance of LoginRequest from another instance of LoginRequest.
     * @param other The LoginRequest you want to clone
     * @returns A cloned LoginRequest
     */
    public static FromOther(other: LoginRequest): LoginRequest {
        return LoginRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return LoginRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'LoginRequest';
}
